(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selected-accessories-browser"]) return;
  try {
    
  if (!customElements.get('selected-accessories-browser')) {
    customElements.define('selected-accessories-browser', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.grid = this.querySelector('[data-sa-grid]');
        this.model = this.querySelector('[data-sa-model]');
        this.search = this.querySelector('[data-sa-search]');
        this.sort = this.querySelector('[data-sa-sort]');
        this.loading = this.querySelector('[data-sa-loading]');
        const initial = new URL(location.href).searchParams;
        this.state = { discount:initial.get('sa_discount')==='50'?50:0, category:initial.get('sa_category') || '', group:initial.get('sa_device') || '', model:initial.get('sa_model') || '', search:initial.get('sa_search') || '', sort:initial.get('sa_sort') || 'featured', page:Number(initial.get('sa_page')) || 1 };
        try {
          this.config = JSON.parse(this.querySelector('[data-sa-config]').textContent);
          this.guideCopy = JSON.parse(this.querySelector('[data-sa-guide-copy]').textContent);
          this.populateGroups();
          this.bindControls();
          this.dataset.controlsReady = 'true';
          this.catalogPromise = this.loadCatalog();
          this.apply(false);
        } catch (error) {
          this.showError();
        }
      }

      async loadCatalog() {
        try {
          const pages = Array.from({length:Number(this.dataset.catalogPages)}, (_,i)=>i+1);
          const batches = await Promise.all(pages.map(async page=>{
            const url = new URL(this.dataset.collectionUrl, location.origin);
            url.searchParams.set('page', String(page));
            url.searchParams.set('sections', 'selected-accessories-catalog');
            const response = await fetch(url);
            if (!response.ok) throw new Error('Products unavailable');
            const sections = await response.json();
            if (!sections['selected-accessories-catalog']) throw new Error('Section unavailable');
            const doc = new DOMParser().parseFromString(sections['selected-accessories-catalog'], 'text/html');
            return [...doc.querySelectorAll('[data-sa-card]')];
          }));
          const existing = new Map([...this.grid.querySelectorAll('[data-sa-card]')].map(card=>[card.dataset.productId,card]));
          const seen = new Set();
          this.cards = batches.flat().filter(card=>{
            const id=card.dataset.productId;
            if(seen.has(id) || !this.config.products[id]) return false;
            seen.add(id); return true;
          }).map(card=>existing.get(card.dataset.productId) || card);
          this.cards.forEach(card=>this.decorateCard(card));
          this.catalogReady = true;
          this.dataset.ready = 'true';
          this.querySelector('[data-sa-native-pagination]').hidden = true;
          return true;
        } catch(error) {
          this.showError();
          return false;
        }
      }

      showError() {
        this.loading.hidden = false;
        this.loading.textContent = this.dataset.errorText;
        this.dataset.error = 'true';
        this.grid.removeAttribute('aria-busy');
      }

      bindControls() {
        const categories = this.querySelector('[data-sa-categories]');
        categories.addEventListener('click',event=>{
          const discount=event.target.closest('[data-sa-discount]');
          if(discount){this.state.discount=this.state.discount===50?0:50;this.state.category='';this.state.group='';this.state.model='';this.state.page=1;this.populateModels();this.apply();return;}
          const button=event.target.closest('[data-sa-category]');if(!button)return;
          this.state.category=this.state.category===button.dataset.saCategory?'':button.dataset.saCategory;this.state.discount=0;
          this.state.group='';this.state.model='';this.state.page=1;this.populateModels();this.apply();
        });
        this.querySelector('[data-sa-all]').addEventListener('click',()=>this.querySelector('[data-sa-clear]').click());
        const groups = this.querySelector('[data-sa-groups]');
        groups.addEventListener('click',event=>{
          const button = event.target.closest('[data-sa-group]');
          if (!button) return;
          this.state.group = button.dataset.saGroup;
          this.state.model = '';
          this.state.page = 1;
          this.populateModels();
          this.apply();
        });
        if (!this.config.groups.some(g=>g.id===this.state.group)) this.state.group = '';
        if(!this.config.categories.some(c=>c.id===this.state.category))this.state.category='';
        if(this.state.group) this.state.category=this.categoryForGroup(this.state.group);
        this.populateModels();
        this.search.value = this.state.search;
        this.sort.value = this.state.sort;
        if (!this.sort.value) { this.state.sort='featured'; this.sort.value='featured'; }
        this.model.disabled = this.search.disabled = this.sort.disabled = false;
        this.model.addEventListener('change',()=>{ this.state.model=this.model.value; this.state.page=1; this.apply(); });
        this.search.addEventListener('input',()=>{ clearTimeout(this.searchTimer); this.searchTimer=setTimeout(()=>{ this.state.search=this.search.value; this.state.page=1; this.apply(); },150); });
        this.sort.addEventListener('change',()=>{ this.state.sort=this.sort.value; this.state.page=1; this.apply(); });
        this.querySelector('[data-sa-clear]').addEventListener('click',()=>{
          this.state={discount:0,category:'',group:'',model:'',search:'',sort:'featured',page:1};
          this.search.value=''; this.sort.value='featured'; this.populateModels(); this.apply();
        });
        this.querySelector('[data-sa-previous]').addEventListener('click',()=>{ this.state.page--; this.apply(); this.scrollGrid(); });
        this.querySelector('[data-sa-next]').addEventListener('click',()=>{ this.state.page++; this.apply(); this.scrollGrid(); });
        this.querySelector('[data-sa-page-numbers]').addEventListener('click',event=>{
          const button=event.target.closest('[data-sa-page]');
          if(!button || Number(button.dataset.saPage)===this.state.page)return;
          this.goToPage(Number(button.dataset.saPage));
        });
        this.querySelector('[data-sa-jump]').addEventListener('submit',event=>{
          event.preventDefault();
          const input=this.querySelector('[data-sa-jump-input]');
          if(!input.reportValidity())return;
          this.goToPage(Number(input.value));
        });
        this.pageBreakpoint=window.matchMedia('(max-width: 749px)');
        this.pageBreakpoint.addEventListener('change',()=>{
          if(this.totalPages)this.renderPageNumbers();
        });
      }

      populateGroups() {
        const container=this.querySelector('[data-sa-groups]');
        for(const group of this.config.groups){
          if(container.querySelector(`[data-sa-group="${group.id}"]`))continue;
          const button=document.createElement('button');button.type='button';button.className='sa-device';button.dataset.saGroup=group.id;button.setAttribute('aria-pressed','false');button.textContent=group.title;container.append(button);
        }
      }

      categoryForGroup(group) { return this.config.groups.find(g=>g.id===group)?.category || (['ipad','samsung-tablets'].includes(group)?'tablets':['accessories','apple-watch','airpods'].includes(group)?'accessories':'phones'); }

      newestFirst(a,b) {
        const x=this.config.products[a.dataset.productId],y=this.config.products[b.dataset.productId];
        return Date.parse(y.createdAt)-Date.parse(x.createdAt) || a.dataset.productId.localeCompare(b.dataset.productId);
      }

      populateModels() {
        if(!this.model.options[0].dataset.originalLabel)this.model.options[0].dataset.originalLabel=this.model.options[0].textContent;
        const all = this.model.options[0].cloneNode(true);
        this.model.replaceChildren(all);
        const models = this.config.models.filter(m=>(!this.state.category || this.categoryForGroup(m.group)===this.state.category) && (!this.state.group || m.group===this.state.group)).map(m=>({...m,count:Object.values(this.config.products).filter(p=>(!this.state.discount || p.discountTier===this.state.discount) && (!this.state.category || p.category===this.state.category) && p.models.includes(m.id)).length})).filter(m=>m.count);
        for (const model of models) {
          const option = document.createElement('option');
          option.value = model.id;
          option.textContent = model.title;
          this.model.append(option);
        }
        if (!models.some(m=>m.id===this.state.model)) this.state.model='';
        this.model.value = this.state.model;
      }

      async apply(updateUrl=true) {
        this.updateGuide();
        const request = this.applyRequest = (this.applyRequest || 0) + 1;
        for (const button of this.querySelectorAll('[data-sa-category]')) {
          const active = button.dataset.saCategory === this.state.category;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        }
        for (const button of this.querySelectorAll('[data-sa-group]')) {
          const active = button.dataset.saGroup === this.state.group;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        }
        if (!this.catalogReady) {
          const filtered = this.state.discount || this.state.category || this.state.group || this.state.model || this.state.search || this.state.sort!=='featured' || this.state.page!==1;
          this.loading.hidden = !filtered;
          this.grid.setAttribute('aria-busy', String(!!filtered));
          if (!await this.catalogPromise || request!==this.applyRequest) return;
        }
        this.loading.hidden = true;
        this.grid.removeAttribute('aria-busy');
        const search = this.state.search.trim().toLocaleLowerCase();
        let matching = this.cards.filter(card=>{
          const entry = this.config.products[card.dataset.productId];
          return (!this.state.discount || entry.discountTier===this.state.discount) && (!this.state.category || entry.category===this.state.category) && (!this.state.group || entry.groups.includes(this.state.group)) && (!this.state.model || entry.models.includes(this.state.model)) && (!search || card.dataset.title.toLocaleLowerCase().includes(search));
        });
        const sort = this.state.sort;
        // The unfiltered default keeps the order returned by the Shopify collection.
        const hasFilters = this.state.discount || this.state.category || this.state.group || this.state.model || search;
        const showPinnedDeals = sort === 'featured' &&
          (this.state.category === 'accessories' || this.state.group === 'accessories' || this.state.discount === 50);
        if (showPinnedDeals) {
          const pinnedIds = new Set([
            '8374275276888', '8833709670488', '7736543019096',
            '7728840573016', '8075447828568', '8075448090712',
            '8842372513880', '8777550233688', '8732025552984',
            '8193864630360', '8164967546968', '7885780975704'
          ]);
          // Filtering preserves collection order, including the order of pinned cards.
          const pinned = matching.filter(card=>pinnedIds.has(card.dataset.productId));
          const remaining = matching.filter(card=>!pinnedIds.has(card.dataset.productId));
          remaining.sort((a,b)=>this.newestFirst(a,b));
          matching = pinned.concat(remaining);
        } else if (sort !== 'featured' || hasFilters) {
          matching.sort((a,b)=> sort==='price-ascending' ? Number(a.dataset.price)-Number(b.dataset.price) : sort==='price-descending' ? Number(b.dataset.price)-Number(a.dataset.price) : sort==='title-ascending' ? a.dataset.title.localeCompare(b.dataset.title) : this.newestFirst(a,b));
        }
        const totalPages = Math.max(1,Math.ceil(matching.length/24));
        this.state.page = Math.min(totalPages,Math.max(1,this.state.page));
        for (const card of this.cards) card.hidden = true;
        const visible = matching.slice((this.state.page-1)*24,this.state.page*24);
        for (const card of visible) { card.hidden=false; this.grid.append(card); }
        this.querySelector('[data-sa-count]').textContent=this.dataset.countText.replace('__COUNT__',String(matching.length));
        this.querySelector('[data-sa-empty]').hidden=matching.length!==0;
        const nav=this.querySelector('[data-sa-pagination]');
        nav.hidden=totalPages<=1;
        this.querySelector('[data-sa-previous]').disabled=this.state.page<=1;
        this.querySelector('[data-sa-next]').disabled=this.state.page>=totalPages;
        this.totalPages=totalPages;
        this.renderPageNumbers();
        const jumpInput=this.querySelector('[data-sa-jump-input]');
        jumpInput.max=String(totalPages);
        jumpInput.value=String(this.state.page);
        this.querySelector('[data-sa-page-label]').textContent=this.dataset.pageText.replace('__CURRENT__',String(this.state.page)).replace('__TOTAL__',String(totalPages));
        for(const button of this.querySelectorAll('[data-sa-group]')) {
          const active=button.dataset.saGroup===this.state.group;
          button.classList.toggle('is-active',active);
          button.setAttribute('aria-pressed',String(active));
        }
        const activeFilters = this.querySelector('[data-sa-active]');
        activeFilters.replaceChildren();
        for(const button of this.querySelectorAll('[data-sa-category]')) {
          const active=button.dataset.saCategory===this.state.category;button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));
        }
        for(const button of this.querySelectorAll('[data-sa-group]')) {
          const group=button.dataset.saGroup;
          button.hidden=this.state.category==='accessories' || (!!group && !!this.state.category && this.categoryForGroup(group)!==this.state.category);
        }
        const showDevices=this.state.category!=='accessories';
        this.querySelector('.sa-device-heading').hidden=!showDevices;
        this.querySelector('.sa-devices').hidden=!showDevices;
        this.querySelector('.sa-model-field').hidden=!showDevices;
        this.querySelector('[data-sa-all]').classList.toggle('is-active',!this.state.category);
        const selectedCategory=this.config.categories.find(c=>c.id===this.state.category);
        const selectedGroup = this.config.groups.find(group=>group.id===this.state.group);
        const selectedModel = this.config.models.find(model=>model.id===this.state.model);
        for (const [key,label] of [['discount',this.state.discount===50?this.guideCopy.halfPrice:null],['category',selectedCategory?.title],['group',selectedGroup?.title],['model',selectedModel?.title],['search',this.state.search]]) {
          if (!label) continue;
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.textContent = label;
          const close = document.createElement('span');
          close.textContent = '×';
          close.setAttribute('aria-hidden','true');
          chip.append(close);
          chip.setAttribute('aria-label', this.dataset.removeText.replace('__FILTER__',label));
          chip.addEventListener('click',()=>{
            this.state[key]=''; this.state.page=1;
            if(key==='category') { this.state.group='';this.state.model='';this.populateModels(); }
            if(key==='group') { this.state.model=''; this.populateModels(); }
            if(key==='model') this.model.value='';
            if(key==='search') this.search.value='';
            this.apply();
          });
          activeFilters.append(chip);
        }
        this.querySelector('[data-sa-clear]').hidden=!(this.state.discount || this.state.category || this.state.group || this.state.model || this.state.search || this.state.sort!=='featured');
        if(updateUrl) {
          const url=new URL(location.href);
          for(const key of ['page','sa_discount','sa_category','sa_device','sa_model','sa_search','sa_sort','sa_page']) url.searchParams.delete(key);
          for(const [key,value] of Object.entries({sa_discount:this.state.discount || '',sa_category:this.state.category,sa_device:this.state.group,sa_model:this.state.model,sa_search:this.state.search,sa_sort:this.state.sort==='featured'?'':this.state.sort,sa_page:this.state.page===1?'':this.state.page})) if(value) url.searchParams.set(key,String(value));
          history.replaceState(null,'',url);
        }
      }

      updateGuide() {
        const group=this.config.groups.find(g=>g.id===this.state.group);
        const generalAccessory=this.state.category==='accessories' && (!this.state.group || this.state.group==='accessories');
        this.querySelector('[data-sa-guide-hint]').textContent=generalAccessory?this.guideCopy.accessories:group?this.guideCopy.chooseModel:this.guideCopy.chooseDevice;
        this.querySelector('.sa-model-field').hidden=generalAccessory;
        this.model.disabled=!this.state.group;
        this.model.options[0].textContent=this.state.group?this.model.options[0].dataset.originalLabel:this.guideCopy.chooseFirst;
        for(const button of this.querySelectorAll('[data-sa-group]'))button.hidden=!!this.state.category && !!button.dataset.saGroup && this.categoryForGroup(button.dataset.saGroup)!==this.state.category;
        for(const card of this.querySelectorAll('[data-sa-card]'))this.decorateCard(card);
        const halfButton=this.querySelector('[data-sa-discount]');halfButton.classList.toggle('is-active',this.state.discount===50);halfButton.setAttribute('aria-pressed',String(this.state.discount===50));
        this.dataset.guidedCategory=this.state.category;
      }

      decorateCard(card) {
        const entry=this.config.products[card.dataset.productId];if(!entry)return;
        const info=card.querySelector('.card__information');if(!info)return;
        let hint=info.querySelector('.sa-compatibility');
        if(!hint){hint=document.createElement('p');hint.className='sa-compatibility';info.append(hint);}
        const models=entry.models.map(id=>this.config.models.find(m=>m.id===id)).filter(Boolean);
        if(models.length>1)hint.textContent=this.guideCopy.multiple;
        else if(models.length===1)hint.textContent=models[0].title;
        else hint.textContent=this.guideCopy.compatibility;
        hint.title=models.map(m=>m.title).join(', ');
        let note=this.querySelector('[data-sa-model-confirm]');
        if(!note){note=document.createElement('p');note.dataset.saModelConfirm='';note.className='sa-model-confirm';this.querySelector('[data-sa-grid]').before(note);}
        note.hidden=!this.state.model;note.textContent=this.guideCopy.confirm;
      }

      goToPage(page) {
        this.state.page=Math.min(this.totalPages,Math.max(1,Math.floor(page)));
        this.apply();
        this.scrollGrid();
      }

      renderPageNumbers() {
        const list=this.querySelector('[data-sa-page-numbers]');
        const focused=list.contains(document.activeElement);
        const current=this.state.page;
        const total=this.totalPages;
        const windowSize=this.pageBreakpoint.matches?3:5;
        let pages;
        if(total<=windowSize+2)pages=Array.from({length:total},(_,i)=>i+1);
        else {
          const start=Math.max(2,Math.min(current-Math.floor(windowSize/2),total-windowSize));
          pages=[1,...Array.from({length:windowSize},(_,i)=>start+i),total];
        }
        const nodes=[];
        let previous=0;
        for(const page of pages) {
          if(previous && page-previous>1) {
            const ellipsis=document.createElement('span');
            ellipsis.className='sa-page-ellipsis';
            ellipsis.textContent='…';
            ellipsis.setAttribute('aria-hidden','true');
            nodes.push(ellipsis);
          }
          const button=document.createElement('button');
          button.type='button';button.dataset.saPage=String(page);button.textContent=String(page);
          button.setAttribute('aria-label',list.dataset.label.replace('__PAGE__',String(page)));
          if(page===current) {
            button.className='is-current';
            button.setAttribute('aria-current','page');
          }
          nodes.push(button);previous=page;
        }
        list.replaceChildren(...nodes);
        if(focused)list.querySelector('[aria-current="page"]').focus({preventScroll:true});
      }

      scrollGrid() { this.querySelector('.sa-results-bar').scrollIntoView({behavior:'smooth',block:'start'}); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
